module.exports = __webpack_public_path__ + "img/3.78d891d9.png";